import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export function useMcpAuthorizeDetails(params: {
  client_id?: string;
  response_type?: string;
  redirect_uri?: string;
  state?: string;
  code_challenge?: string;
  code_challenge_method?: string;
}) {
  return useQuery({
    queryKey: ["mcpAuthorizeDetails", params],
    queryFn: async () => await apiClient.getMcpAuthorizeDetails({ queries: params }),
    enabled: !!params.client_id,
  });
}
